<s1-input-select [control]="control" [itemsList]="centers" [label]="label" [grouped]="grouped" [readonly]="readonly"></s1-input-select>